import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IconButton, Row, Typography } from 'seagull';
import { ChevronLeft } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { relationshipModel } from '~/models';
import styles from './MobileHeader.module.scss';
export const GetMobileHeaderTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const MobileHeader = (param)=>{
    let { testId, relationship, showBack, onBack } = param;
    const { MobileHeaderTestIds } = useMemo(()=>GetMobileHeaderTID(testId), [
        testId
    ]);
    const vendorLogoUrl = relationshipModel.vendorLogoUrl({
        vendor: relationship.vendor
    });
    return /*#__PURE__*/ _jsxs(Row, {
        className: styles.root,
        testId: MobileHeaderTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.backButtonSlot,
                children: showBack && onBack && /*#__PURE__*/ _jsx(IconButton, {
                    bi: {
                        name: 'onboarding_mobile_header_back'
                    },
                    className: styles.backButton,
                    onClick: onBack,
                    testId: MobileHeaderTestIds.BackButton(),
                    children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.logoSlot,
                children: vendorLogoUrl ? /*#__PURE__*/ _jsx("img", {
                    src: vendorLogoUrl,
                    alt: relationship.vendor.name,
                    className: styles.vendorLogo,
                    "data-testid": MobileHeaderTestIds.VendorLogo()
                }) : /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    weight: "normal",
                    testId: MobileHeaderTestIds.VendorName(),
                    children: relationship.vendor.name
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.spacer
            })
        ]
    });
};
